import './App.css';
import { IDeleteData } from './UI/Interfaces';

// Empty string = relative URLs (same origin). Nginx on the server routes the API paths to the backend.
// For local dev, set REACT_APP_API_URL=http://localhost:10010 in .env.development
const urlCore = process.env.REACT_APP_API_URL ?? "";

function Api() {}

export default Api;

// export const getAllSlots = async () => {
//   try {
//     const response = await fetch(urlCore + "/get-all-slots");
//     if (!response.ok) {
//       throw new Error("Network response was not ok");
//     }
//     return await response.json();
//   } catch (error) {
//     console.error("/get-all-slots: " + error);
//   }
// };

export const getHistoryRecords = async () => {
    try {
        const response = await fetch(urlCore + '/get-slot-history');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('/get-slot-history: ' + error);
    }
};

export const postData = async (data: any) => {
    try {
        const response = await fetch(urlCore + '/create-reservation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            throw new Error('Network response was not ok. Status code: ' + response.status);
        }
        return await response.json();
    } catch (error) {
        console.error('/create-reservation: ' + error);
    }
};

export const deleteRecord = async (data: IDeleteData) => {
    try {
        const { slot, time } = data;
        const response = await fetch(`${urlCore}/delete-reservation/${slot}/${time}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('/delete-reservation: ' + error);
    }
};
